import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { signOutAction } from "../../../redux/actions/authentication/authenticationAction";
import { FiSettings, FiUser } from "react-icons/fi";
import { IconContext } from "react-icons";
import { MdOutlineAdminPanelSettings } from "react-icons/md";
import { BiPurchaseTagAlt } from "react-icons/bi";

export const UserHeader = (props) => {
  const pathname = window.location.pathname;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [settings, setSettings] = useState(false);


  const getAttribute = () => {
    switch (pathname) {
      case "/user/dashboard":
        return "ni nicon-notification blue-icon";
      case "/user/profile":
        return "ni nicon-notification blue-icon";
      case "/user/analytics":
        return "ni nicon-notification red-icon";
      case "/user/profile-analytics":
        return "ni nicon-notification red-icon";
      case "/user/network":
        return "ni nicon-notification orange-icon";
      case "/user/notifications":
        return "ni nicon-notification orange-icon";
      case "/user/contact/":
        return "ni nicon-notification orange-icon";
      case "/user/performance":
        return "ni nicon-notification green-icon";
      default:
        return "ni nicon-notification blue-icon";
    }
  };

  const singoutUser = () => {
    dispatch(signOutAction(navigate));
  
  };

  const [isTrue, setIsTrue] = useState(true);

  const handleMenuActive = () => {
    setIsTrue(!isTrue);
    props.parentCallback(isTrue);
  };

  const handleSettings = () => {
    setSettings(!settings);
  };

  return (
    <div className="">
      <header className="dashboard-nav">
        <div className="container">
          <div className="row align-items-start dash-header">
            <div className="col-md-6 col-6 d-flex align-items-center">
              <Link
                to=""
                className={
                  isTrue === true
                    ? "nav-toggler-dashboard mr-2 d-block d-lg-none"
                    : "nav-toggler-dashboard mr-2 d-block d-lg-none  open"
                }
                id="nav-icon2"
                onClick={handleMenuActive}
              >
                <span></span>
                <span></span>
                <span></span>
              </Link>
              <Link to="/user/dashboard" className="nav-logo">
                <img src="/assets/images/logo-dashboard.svg" alt="" />
              </Link>
            </div>
            <div className="col-md-6 col-6" style={window.innerWidth <= 768 ? {marginBottom: "0px"}:{}}>
              <div className="right-nav">
                <Link to="/user/notifications" 
                style={window.innerWidth <= 768 ? {paddingBottom:"8px"}: {}}
                >
                  {/* Notifications */}
                  <span className="icon">
                    <img
                      className={getAttribute()}
                      src="/assets/images/notification-bell.svg"
                    />
                  </span>
                </Link>
                &nbsp;
                <div className="dropdown">
                  <Link to="" onClick={handleSettings}>
                    <span className="icon ">
                      <IconContext.Provider
                        value={{ className: getAttribute() }}
                      >
                        <img
                          className={getAttribute()}
                          src="/assets/images/settings.svg"
                        />
                      </IconContext.Provider>
                    </span>
                  </Link>

                  <ul
                    className={
                      settings ? "dropdown-menu show" : "dropdown-menu"
                    }
                    aria-labelledby="navbarDropdownMenuLink"
                  >
                    {props.user && props.user.is_superuser ? (
                      <li>
                        <Link className="dropdown-item" to="/admin">
                          <IconContext.Provider
                            value={{
                              className: "global-class-name",
                            }}
                          >
                            <MdOutlineAdminPanelSettings /> Admin
                          </IconContext.Provider>
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                    <li className="dropdown-submenu ">
                      <Link
                        className="dropdown-item"
                        to="/user/accountSettings"
                      >
                        <IconContext.Provider
                          value={{
                            className: "global-class-name",
                          }}
                        >
                          <FiUser /> Account Settings
                        </IconContext.Provider>
                      </Link>
                    </li>
                    <li className="dropdown-submenu ">
                      <Link
                        className="dropdown-item"
                        to="/user/subscriptionPlan"
                      >
                        <IconContext.Provider
                          value={{
                            className: "global-class-name",
                          }}
                        >
                          <BiPurchaseTagAlt /> Subscription Plan
                        </IconContext.Provider>
                      </Link>
                    </li>
                  </ul>
                </div>
                <Link to="" className="btn mb-4" 
                // style={isMobile ? {marginTop: "10px"} : {}}  
                style={window.innerWidth <= 768 ? {marginTop: "15px"}: {}}
                onClick={() => singoutUser()}>
                  <span>Log out</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

const mapStateToProps = (state) => {
  const authUser = state.user.user;
  const userProfile = state.user.profile;

  return {
    user: authUser,
    profile: userProfile,
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(UserHeader);
